<div class="kf-editable-field">
    @if (isEditable$ | async; as editable) {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <!--TODO: @Input() typeAheadList$: Observable<string[]>  // this attribute defines a typeahead list. -->
            <div class="kf-input-label justify-content-between" [class.d-flex]="maxLength" [class.kf-input-label-counter]="maxLength">
                <label for="{{id}}">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </label>
                @if (maxLength) {
                    <div class="label-count">
                        @if (obj[prop]) {
                            <div class="text-end">
                                <small class="fst-italic">{{obj[prop]?.name?.length ?? obj[prop].length}}/{{maxLength}}</small>
                            </div>
                        }
                        @if (!obj[prop]) {
                            <div class="text-end">
                                <small class="fst-italic">0/{{maxLength}}</small>
                            </div>
                        }
                    </div>
                }
            </div>
            <!-- INPUT BOX version - Typeahead pop-up -->
            <ng-template #popup let-result="result" let-term="term">
                <div class="row d-block">
                    <div class="d-inline p-0">
                        @if (result.img != undefined) {
                            <img src="{{result.img}}" class="rounded img-fluid" alt="Photo of {{result.name}}" />
                        }
                        @if (result.iconClass != undefined) {
                            <i class="{{result.iconClass}}"></i>
                        }
                    </div>
                    <div class="d-inline-block align-middle pe-4" [class.text-decoration-line-through]="!!result?.personId && !result?.isActive">
                        <ngb-highlight [result]="result.name" [term]="term" class="title"></ngb-highlight>
                        @if (result.desc != undefined) {
                            <div class="subtitle">{{result.desc}}</div>
                        }
                    </div>
                </div>
            </ng-template>
            <!-- INPUT BOX version - Input -->
            <div class="kf-input col position-relative">
                @if (maxLength) {
                    <div class="input-count">
                        @if (obj[prop]) {
                            <div class="text-end">
                                <small class="fst-italic">{{obj[prop]?.name?.length ?? obj[prop].length}}/{{maxLength}}</small>
                            </div>
                        }
                        @if (!obj[prop]) {
                            <div class="text-end">
                                <small class="fst-italic">0/{{maxLength}}</small>
                            </div>
                        }
                    </div>
                }
                <div class="d-flex">
                    @if (mode==inputMode.Text) {
                        <input type="text" class="input-text w-100"
                               [class.input-error]="showInputErrorIcon"
                               [class.input-warning]="showInputWarningIcon"
                               [ngModel]="_displayValue"
                               (ngModelChange)="onEdit($event); onTypeaheadOptionSelect($event);"
                               (change)="onChange()"
                               [id]="id"
                               [placeholder]="placeholder"
                               [attr.maxlength]="maxLength"
                               [ngbTypeahead]="search"
                               popupClass="kf-typeahead"
                               (keyup.arrowdown)="navigateResults($event)"
                               (keyup.arrowup)="navigateResults($event)"
                               (focus)="focusOpenTypeahead ? openTypeahead() : null"
                               (click)="focusOpenTypeahead ? openTypeahead() : null"
                               [resultTemplate]="popup"
                               [inputFormatter]="formatInput"
                               [disabled]="isDisabled"
                               #ngbInstance="ngbTypeahead"
                               #ngbElement />
                    }
                    <!-- TEXT AREA version -->
                    <!-- Add character counter -->
                    @if (mode==inputMode.TextArea) {
                        <textarea class="input-textarea w-100"
                                  [class.input-error]="showInputErrorIcon"
                                  [class.input-warning]="showInputWarningIcon"
                                  [ngModel]="obj[prop]"
                                  (ngModelChange)="obj[prop]=$event;validate()"
                                  (change)="onChange()"
                                  [id]="id"
                                  [placeholder]="placeholder"
                                  [attr.maxlength]="maxLength"
                                  [ngStyle]="{'height': !!textAreaDefaultHeight ? textAreaDefaultHeight + 'px' : 'inherit'}"
                                  #kfTextArea>
                        </textarea>
                    }
                    <!-- NUMBER version -->
                    @if (mode==inputMode.Number) {
                        <input type="number" class="input-number w-100"
                               [class.input-error]="showInputErrorIcon"
                               [class.input-warning]="showInputWarningIcon"
                               [ngModel]="obj[prop]"
                               (ngModelChange)="obj[prop]=$event;validate()"
                               (change)="onChange()"
                               [id]="id"
                               [placeholder]="placeholder"
                               [min]="minValue"
                               [max]="maxValue"
                               [step]="step" />
                    }
                    @if (isDisabled) {
                        <div class="ms-1">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                        </div>
                    }
                </div>
                
                @if(showInputErrorIcon){
                    <!-- optional decorative icon inside the input -->
                    <i class="fas fa-exclamation-triangle kf-bg-clear kf-element kf-danger-red error-icon"
                       [class.number]="mode == inputMode.Number"
                       [class.text-area]="mode == inputMode.TextArea"
                       aria-hidden="true"></i>
                }
                
                @if(showInputWarningIcon){
                    <!-- optional decorative icon inside the input -->
                    <i class="fas fa-flag kf-element kf-bg-clear kf-warning-yellow warning-icon"
                       [class.number]="mode == inputMode.Number"
                       [class.text-area]="mode == inputMode.TextArea"
                       aria-hidden="true"></i>
                }
            </div>
        </div>
        
        <!--  Errors/Warnings  -->
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
    @else {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <div class="kf-input-label">
                <div class="kf-label">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </div>
            </div>
            <div class="kf-input col kf-pre-line read-only-value">
                {{ _displayValue }}
            </div>
        </div>
        @if (!!allowReadOnlyWarnings) {
            @if (this.warning$ | async; as warning) {
                <!--  Optionally show warnings only in read-only mode  -->
                <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true" [supressErrors]="true"></observable-errors-warnings>
            }
        }
    }
</div>

